import { usePermissions } from '@/contexts/PermissionsContext';
import { savRequestsService } from '@/services/savRequestsService';
import { useQuery } from '@tanstack/react-query';

export const SAV_REQUESTS_UNREAD_COUNT_KEY = ['sav-requests-unread-count'] as const;

/**
 * Nombre de nouvelles demandes SAV du site (non lues, hors spam), actualisé toutes les 60 s (pas de Realtime).
 * Désactivé sans la permission 'sav_requests' : aucune requête pour les autres utilisateurs.
 * En cas d'erreur : valeur indéfinie (le badge reste masqué), nouvel essai à l'intervalle suivant.
 */
export function useSavRequestsUnreadCount() {
  const { hasPermission, isLoading } = usePermissions();
  const allowed = !isLoading && hasPermission('sav_requests');

  const query = useQuery({
    queryKey: SAV_REQUESTS_UNREAD_COUNT_KEY,
    queryFn: () => savRequestsService.getUnreadCount(),
    enabled: allowed,
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    retry: false,
  });

  return { allowed, count: query.data, isError: query.isError };
}
